export default {
  getConversions: (t) => {
    return {
      "RWidget-CallbackForm": {
        color: "#2196F3",
        icon: "/images/widget-conversion-callback.png",
        title: t("__ads_widget_action_callback_form"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 1,
      },
      "RWidget-GoogleMaps": {
        color: "#ea453b",
        icon: "/images/widget-conversion-google-maps.png",
        title: t("__ads_widget_action_google_maps"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 2,
      },
      "RWidget-Zalo": {
        color: "#008FE5",
        icon: "/images/widget-conversion-zalo.png",
        title: t("__ads_widget_action_zalo"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 3,
      },
      "RWidget-Skype": {
        color: "#00B0F0",
        icon: "/images/widget-conversion-skype.png",
        title: t("__ads_widget_action_skype"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 4,
      },
      "RWidget-WhatsApp": {
        color: "#00E676",
        icon: "/images/widget-conversion-whatsapp.png",
        title: t("__ads_widget_action_whatsapp"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 5,
      },
      "RWidget-FacebookMessenger": {
        color: "#2173f3",
        icon: "/images/widget-conversion-facebook.png",
        title: t("__ads_widget_action_facebook"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 6,
      },
      "RWidget-LINE": {
        color: "#00b800",
        icon: "/images/widget-conversion-line.png",
        title: t("__ads_widget_action_line"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 7,
      },
      "RWidget-PhoneCall": {
        color: "#FF9c00",
        icon: "/images/widget-conversion-phone-call.png",
        title: t("__ads_widget_action_call"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 8,
      },
      "RWidget-ContactForm": {
        color: "#4cb48b",
        icon: "/images/widget-conversion-contact-form.png",
        title: t("__ads_widget_action_form"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 9,
      },
      "RWidget-RChat": {
        color: "#65A6FF",
        icon: "/images/widget-conversion-r-chat.png",
        title: t("__ads_widget_action_rchat"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 10,
      },
      "RWidget-CustomButton": {
        color: "#607D8B",
        icon: "/images/widget-conversion-custom-button.png",
        title: t("__ads_widget_action_custom_button"),
        lastSend: "",
        name: "",
        value: "0.00",
        id: 11,
      },
    };
  },
};
